export function normalizeFullName(value: string): string {
  return value.trim().replace(/\s+/g, ' ')
}
